// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Ejzge","user":"Header_user__o2lKI","main-image":"Header_main-image__IvWnY"};